<template>
    <footer class="py-5 text-center">
        <div class="d-flex flex-wrap justify-content-center gap-4 mb-4 opacity-50">
            <div class="small fw-bold"><i class="fa-solid fa-shield-halved me-2"></i>WHO COMPLIANT</div>
            <div class="small fw-bold"><i class="fa-solid fa-certificate me-2"></i>LICENSED PARTNERS</div>
            <div class="small fw-bold"><i class="fa-solid fa-lock me-2"></i>ENCRYPTED DATA</div>
            <div class="small fw-bold"><i class="fa-solid fa-user-shield me-2"></i>PRIVACY-FIRST</div>
        </div>
        <p class="text-muted small">&copy; 2026 JeevanDaan+ | National Health Portal Affiliate</p>
    </footer>



</template>
<style>
    .footer {
            background-color: #212529;
            color: #fff;
            padding: 2rem 0;
            margin-top: 3rem;
            border-radius: 1rem 1rem 0 0;
        }
</style>